export default {
  meta: {
    title: '出勤签到',
    url: '/attendance', //  埋点字段，上报归属的模块
    urlName: '出勤签到' //  埋点字段，上报归属的模块
    // eventId: 'dad03a81-38bf-49a1-b77f-02f1dc2cdeb9'
  }
};
